import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=bd1e5760&"
import script from "./XInput.vue?vue&type=script&lang=ts&"
export * from "./XInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../tbestpro-management/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports